/* OVIKSA — scripts propios */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Deslizar con el dedo a izquierda o derecha, sin estorbar el scroll vertical
  function alDeslizar(el, alIzq, alDer) {
    var x0 = null, y0 = 0;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      el.dataset.ovDeslizo = Date.now();
      if (dx < 0) alIzq(); else alDer();
    }, { passive: true });
    // Tras deslizar no se sigue el enlace que hubiera debajo del dedo
    el.addEventListener('click', function (e) {
      if (Date.now() - (parseInt(el.dataset.ovDeslizo, 10) || 0) < 400) e.preventDefault();
    }, true);
  }

  // Vibración corta (solo los celulares que la permiten, sobre todo Android)
  function vibrar(ms) {
    try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {}
  }

  // Aviso breve en la parte baja de la pantalla
  function aviso(texto) {
    var a = document.querySelector('.ov-aviso');
    if (!a) { a = document.createElement('div'); a.className = 'ov-aviso'; a.setAttribute('role', 'status'); document.body.appendChild(a); }
    a.textContent = texto;
    void a.offsetWidth;
    a.classList.add('ov-visible');
    clearTimeout(a.__ovT);
    a.__ovT = setTimeout(function () { a.classList.remove('ov-visible'); }, 2200);
  }

  // Compartir: en el celular abre el menú de compartir del propio teléfono; si no existe, copia el enlace
  function compartir(datos, textoCopiado) {
    if (navigator.share) { navigator.share(datos).catch(function () {}); return; }
    var listo = function () { aviso(textoCopiado || 'Enlace copiado'); };
    var viejo = function () {
      var t = document.createElement('textarea');
      t.value = datos.url; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
      listo();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(datos.url).then(listo, viejo);
    else viejo();
  }

  // Fotos a pantalla completa: se pasan deslizando, se amplían tocando la foto o con dos dedos
  function abrirVisor(minis, indice, alCerrar) {
    if (document.querySelector('.ov-visor')) return;
    var visor = document.createElement('div');
    visor.className = 'ov-visor';
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-modal', 'true');
    visor.setAttribute('aria-label', 'Fotos del producto');
    var cerrarBtn = document.createElement('button');
    cerrarBtn.type = 'button';
    cerrarBtn.className = 'ov-visor__cerrar';
    cerrarBtn.setAttribute('aria-label', 'Cerrar');
    cerrarBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var cuenta = document.createElement('div');
    cuenta.className = 'ov-visor__cuenta';
    var pista = document.createElement('div');
    pista.className = 'ov-visor__pista';
    minis.forEach(function (m, i) {
      var hoja = document.createElement('div');
      hoja.className = 'ov-visor__foto';
      var img = document.createElement('img');
      img.alt = m.dataset.alt || '';
      img.loading = i === indice ? 'eager' : 'lazy';
      img.sizes = '100vw';
      if (m.dataset.srcset) img.srcset = m.dataset.srcset;
      img.src = m.dataset.src;
      hoja.appendChild(img);
      pista.appendChild(hoja);
      // Tocar la foto la amplía hacia el punto tocado; tocarla de nuevo la devuelve a su tamaño
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        var r = img.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        var ampliar = !hoja.classList.contains('ov-zoom');
        hoja.classList.toggle('ov-zoom', ampliar);
        if (ampliar) {
          hoja.scrollLeft = img.offsetWidth * fx - hoja.clientWidth / 2;
          hoja.scrollTop = img.offsetHeight * fy - hoja.clientHeight / 2;
        }
      });
      // Tocar el fondo oscuro cierra
      hoja.addEventListener('click', function () { if (!hoja.classList.contains('ov-zoom')) cerrar(); });
    });
    visor.appendChild(pista);
    visor.appendChild(cuenta);
    visor.appendChild(cerrarBtn);
    var actual = indice;
    function pintar() { cuenta.textContent = (actual + 1) + ' / ' + minis.length; }
    var antesFoco = document.activeElement;
    var antesOverflow = document.documentElement.style.overflow;
    function tecla(e) { if (e.key === 'Escape') cerrar(); }
    function cerrar() {
      document.removeEventListener('keydown', tecla);
      document.documentElement.style.overflow = antesOverflow;
      visor.classList.remove('ov-abierto');
      setTimeout(function () { if (visor.parentNode) visor.parentNode.removeChild(visor); }, 250);
      if (antesFoco && antesFoco.focus) antesFoco.focus();
      if (alCerrar) alCerrar(actual);
    }
    cerrarBtn.addEventListener('click', cerrar);
    document.addEventListener('keydown', tecla);
    pista.addEventListener('scroll', function () {
      var n = Math.round(pista.scrollLeft / (pista.clientWidth || 1));
      if (n !== actual && n >= 0 && n < minis.length) {
        // Al cambiar de foto, la anterior vuelve a su tamaño normal
        var z = pista.querySelector('.ov-zoom'); if (z) z.classList.remove('ov-zoom');
        actual = n; pintar();
      }
    }, { passive: true });
    // Deslizar el dedo hacia abajo cierra el visor (la foto acompaña al dedo; si se suelta pronto, vuelve a su sitio)
    var y0 = null, x0 = 0, bajando = false, dy = 0;
    pista.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || pista.querySelector('.ov-zoom')) { y0 = null; return; }
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; bajando = false; dy = 0;
    }, { passive: true });
    pista.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      var t = e.touches[0];
      dy = t.clientY - y0;
      if (!bajando) {
        if (e.touches.length !== 1 || dy < 12 || dy < Math.abs(t.clientX - x0) * 1.4) return;
        bajando = true;
        pista.style.transition = 'none';
      }
      var d = Math.max(0, dy);
      pista.style.transform = 'translateY(' + d + 'px) scale(' + Math.max(0.86, 1 - d / 1400) + ')';
      visor.style.backgroundColor = 'rgba(8, 16, 14, ' + Math.max(0.3, 0.97 - d / 450) + ')';
    }, { passive: true });
    function soltar() {
      if (y0 === null) return;
      y0 = null;
      if (!bajando) return;
      bajando = false;
      pista.style.transition = 'transform .22s ease';
      if (dy > 110) {
        pista.style.transform = 'translateY(70vh) scale(.86)';
        cerrar();
      } else {
        pista.style.transform = '';
        visor.style.backgroundColor = '';
      }
    }
    pista.addEventListener('touchend', soltar, { passive: true });
    pista.addEventListener('touchcancel', soltar, { passive: true });

    document.body.appendChild(visor);
    document.documentElement.style.overflow = 'hidden';
    pista.scrollLeft = pista.clientWidth * indice;
    pintar();
    requestAnimationFrame(function () { visor.classList.add('ov-abierto'); });
    cerrarBtn.focus();
  }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.ov-reveal:not(.ov-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ov-visible'); });
      return;
    }
    if (!window.__ovObserver) {
      window.__ovObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ov-visible');
            window.__ovObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__ovObserver.observe(el); });
  }

  function initComparadores(root) {
    (root || document).querySelectorAll('[data-ov-ba]').forEach(function (wrap) {
      if (wrap.dataset.ovListo) return;
      wrap.dataset.ovListo = '1';
      var range = wrap.querySelector('.ov-ba__rango');
      if (!range) return;
      var set = function () { wrap.style.setProperty('--ov-pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();

      // Demostración: la primera vez que se ve, la línea se mueve sola para invitar a arrastrarla
      var tocado = false;
      ['input', 'pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
        range.addEventListener(ev, function () { tocado = true; }, { passive: true });
      });
      function demo() {
        if (tocado) return;
        var ini = parseFloat(range.value) || 50;
        var puntos = [ini, Math.max(12, ini - 30), Math.min(88, ini + 30), ini];
        var dur = 2000, t0 = null;
        function paso(t) {
          if (tocado) { set(); return; }
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var seg = Math.min(2, Math.floor(p * 3)), l = p * 3 - seg;
          var suave = l < 0.5 ? 2 * l * l : 1 - Math.pow(-2 * l + 2, 2) / 2;
          wrap.style.setProperty('--ov-pos', (puntos[seg] + (puntos[seg + 1] - puntos[seg]) * suave) + '%');
          if (p < 1) requestAnimationFrame(paso); else set();
        }
        requestAnimationFrame(paso);
      }
      if (!reduce && 'IntersectionObserver' in window) {
        var ioDemo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            ioDemo.disconnect();
            setTimeout(demo, 500);
          });
        }, { threshold: 0.6 });
        ioDemo.observe(wrap);
      }
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-ov-producto]').forEach(function (sec) {
      if (sec.dataset.ovListo) return;
      sec.dataset.ovListo = '1';

      // Galería
      var principal = sec.querySelector('[data-ov-principal]');
      var minis = Array.prototype.slice.call(sec.querySelectorAll('[data-ov-mini]'));
      var video = sec.querySelector('[data-ov-video]');
      var actual = 0;
      function mostrar(i) {
        if (!principal || !minis.length) return;
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        // La miniatura de video cambia la foto por el video (sin sonido); al salir se pausa
        var esVideo = !!(video && m.dataset.video);
        if (video) {
          video.hidden = !esVideo;
          principal.hidden = esVideo;
          if (esVideo) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); } else video.pause();
        }
        minis.forEach(function (x, j) { x.classList.toggle('ov-activa', j === actual); });
        if (esVideo) return;
        principal.classList.add('ov-cambiando');
        setTimeout(function () {
          principal.src = m.dataset.src;
          principal.srcset = m.dataset.srcset || '';
          principal.alt = m.dataset.alt || '';
          principal.classList.remove('ov-cambiando');
        }, 180);
        minis.forEach(function (x, j) { x.classList.toggle('ov-activa', j === actual); });
        // La tira de miniaturas acompaña a la foto: la activa queda a la vista (solo se mueve la tira, no la página)
        var tira = m.parentElement;
        if (tira && tira.scrollWidth > tira.clientWidth) {
          var x = tira.scrollLeft + (m.getBoundingClientRect().left - tira.getBoundingClientRect().left) - (tira.clientWidth - m.offsetWidth) / 2;
          if (tira.scrollTo) tira.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' }); else tira.scrollLeft = x;
        }
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      var prev = sec.querySelector('[data-ov-prev]');
      var next = sec.querySelector('[data-ov-next]');
      if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
      if (next) next.addEventListener('click', function () { mostrar(actual + 1); });
      if (principal && minis.length > 1) {
        alDeslizar(principal.parentElement, function () { mostrar(actual + 1); }, function () { mostrar(actual - 1); });
      }
      // Tocar la foto la abre a pantalla completa (al cerrar, la galería queda en la última foto vista)
      if (principal && minis.length) {
        principal.addEventListener('click', function (e) {
          if (e.defaultPrevented) return;
          // El visor solo muestra fotos: se le pasa la lista sin la miniatura de video
          var fotos = minis.filter(function (x) { return !x.dataset.video; });
          abrirVisor(fotos, Math.max(0, fotos.indexOf(minis[actual])), function (n) {
            var j = minis.indexOf(fotos[n]);
            if (j !== actual) mostrar(j);
          });
        });
      }

      // Botón de compartir sobre la foto
      var comp = sec.querySelector('[data-ov-compartir]');
      if (comp) comp.addEventListener('click', function (e) {
        e.stopPropagation();
        var titulo = comp.dataset.titulo || document.title;
        vibrar(10);
        compartir({
          title: titulo,
          text: comp.dataset.texto ? comp.dataset.texto + ' ' + titulo : titulo,
          url: comp.dataset.url || (window.location.origin + window.location.pathname)
        }, comp.dataset.copiado);
      });

      // Cantidad + enlace de pago contra entrega
      var qty = sec.querySelector('[data-ov-qty]');
      var cod = sec.querySelector('[data-ov-cod]');
      var pagar = sec.querySelector('[data-ov-pagar]');
      var qtyForm = sec.querySelector('[data-ov-qty-form]');
      function syncCod() {
        var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
        if (qtyForm) qtyForm.value = q;
        var idEl = sec.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        var base = (window.routes && window.routes.cart_url) || '/cart';
        if (!idEl) return;
        if (cod) cod.href = base + '/' + idEl.value + ':' + q;
        if (pagar) pagar.href = base + '/' + idEl.value + ':' + q;
      }
      // Si el cliente ya tiene cosas en el carrito, los botones de pago de la ficha suman este producto
      // al carrito y cobran todo junto; con el carrito vacío se paga solo este producto, como siempre.
      function juntarConCarrito(listo, solo) {
        var idEl = sec.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        var id = idEl ? parseInt(idEl.value, 10) : 0;
        var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var drawer = document.querySelector('cart-drawer');
        var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : null;
        var post = function (ruta, cuerpo) {
          if (secciones) { cuerpo.sections = secciones; cuerpo.sections_url = window.location.pathname; }
          return fetch(raiz + ruta, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) }).then(function (r) { return r.json(); });
        };
        fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          if (!id || !c || !c.item_count) { solo(); return; }
          var ya = null;
          (c.items || []).forEach(function (it) { if (it.variant_id === id) ya = it; });
          if (ya && c.items.length === 1) { solo(); return; } // solo tiene este mismo producto: se paga lo elegido en la ficha
          var paso = !ya ? post('cart/add.js', { items: [{ id: id, quantity: q }] })
            : (ya.quantity < q ? post('cart/change.js', { id: ya.key, quantity: q }) : Promise.resolve(null));
          return paso.then(function (res) {
            if (res && res.status) { solo(); return; }
            if (res && res.sections && drawer) { try { pintarCarrito(drawer, res); } catch (e) {} }
            listo(drawer);
          });
        }).catch(solo);
      }
      function botonCarritoApp() {
        var todos = document.querySelectorAll('#rsi_buy_now_button');
        for (var i = 0; i < todos.length; i++) { if (!todos[i].closest('form[data-type="add-to-cart-form"]') && !todos[i].closest('#floatingBuyNowButton')) return todos[i]; }
        return null;
      }
      function ocupado(b, si) { b.classList.toggle('ov-btn--ocupado', si); }
      if (cod) cod.addEventListener('click', function (e) {
        if (cod.classList.contains('ov-btn--ocupado')) { e.preventDefault(); return; }
        var app = sec.querySelector('form[data-type="add-to-cart-form"] #rsi_buy_now_button');
        e.preventDefault();
        syncCod();
        vibrar(10);
        ocupado(cod, true);
        var solo = function () { ocupado(cod, false); if (app) app.click(); else window.location.href = cod.href; };
        juntarConCarrito(function (drawer) {
          // Espera un momento a que la app vuelva a poner su botón en el carrito recién pintado
          var intentos = 0;
          (function buscar() {
            var b = botonCarritoApp();
            if (b) { ocupado(cod, false); b.click(); return; }
            if (++intentos < 12) { setTimeout(buscar, 150); return; }
            ocupado(cod, false);
            if (drawer && drawer.open) drawer.open(); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          })();
        }, solo);
      });
      if (pagar) pagar.addEventListener('click', function (e) {
        if (pagar.classList.contains('ov-btn--ocupado')) { e.preventDefault(); return; }
        e.preventDefault();
        syncCod();
        ocupado(pagar, true);
        juntarConCarrito(function () { window.location.href = '/checkout'; }, function () { ocupado(pagar, false); window.location.href = pagar.href; });
      });
      sec.querySelectorAll('[data-ov-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v = b.dataset.ovQtyBtn === 'mas' ? v + 1 : Math.max(1, v - 1);
          qty.value = v;
          syncCod();
        });
      });
      if (qty) { qty.addEventListener('change', syncCod); qty.addEventListener('input', syncCod); }

      // Formato de dinero de la tienda
      var fmt = sec.dataset.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';
      function money(cents) {
        var v = cents / 100;
        var conDec = v.toFixed(2).split('.');
        var sinDec = Math.round(v).toString();
        var miles = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          switch (k) {
            case 'amount': return miles(conDec[0], ',') + '.' + conDec[1];
            case 'amount_no_decimals': return miles(sinDec, ',');
            case 'amount_with_comma_separator': return miles(conDec[0], '.') + ',' + conDec[1];
            case 'amount_no_decimals_with_comma_separator': return miles(sinDec, '.');
            case 'amount_with_apostrophe_separator': return miles(conDec[0], "'") + '.' + conDec[1];
            default: return miles(sinDec, '.');
          }
        });
      }
      var precioEl = sec.querySelector('[data-ov-precio]');
      var antesEl = sec.querySelector('[data-ov-antes]');
      var ahorroEl = sec.querySelector('[data-ov-ahorro]');

      // Packs (kit x2, pack x4...): fijan la cantidad y el precio mostrado
      var packs = sec.querySelector('[data-ov-packs]');
      function pintarPacks() {
        if (!packs) return;
        var precio = parseInt(packs.dataset.precio, 10) || 0;
        var antesU = parseInt(packs.dataset.antes, 10) || 0;
        packs.querySelectorAll('input[type=radio]').forEach(function (r) {
          var q = parseInt(r.dataset.q, 10) || 1;
          var d = parseInt(r.dataset.desc, 10) || 0;
          var total = precio * q - d;
          var ant = d > 0 ? precio * q : antesU * q;
          var lab = packs.querySelector('label[for="' + r.id + '"]');
          if (lab) {
            var t = lab.querySelector('[data-ov-pack-total]'); if (t) t.textContent = money(total);
            var u = lab.querySelector('[data-ov-pack-unidad]'); if (u) u.textContent = (u.dataset.tpl || '[precio]').replace('[precio]', money(Math.round(total / q)));
            var a = lab.querySelector('[data-ov-pack-antes]'); if (a) a.textContent = money(ant);
            var h = lab.querySelector('[data-ov-pack-ahorro]'); if (h) h.textContent = (h.dataset.tpl || '') + ' ' + money(ant - total);
          }
          if (r.checked) {
            if (qty) qty.value = q;
            if (precioEl) precioEl.textContent = money(total);
            var hay = ant > total;
            if (antesEl) { antesEl.hidden = !hay; antesEl.textContent = money(ant); }
            if (ahorroEl) { ahorroEl.hidden = !hay; if (hay) ahorroEl.textContent = '-' + Math.round((ant - total) * 100 / ant) + '%'; }
            var nota = sec.querySelector('[data-ov-precio-nota]');
            if (nota) {
              // Con 1 unidad se usa el texto en singular; si está vacío, la nota se oculta
              var tplNota = q === 1 ? (nota.dataset.tplUno || '') : (nota.dataset.tpl || '');
              nota.textContent = tplNota.replace('[n]', q);
              nota.hidden = !tplNota;
            }
            var bp = document.querySelector('[data-ov-barra-precio]');
            if (bp) bp.textContent = money(total);
          }
        });
        syncCod();
      }
      if (packs) packs.addEventListener('change', function (e) {
        pintarPacks();
        // La opción elegida confirma con un pequeño pulso (y una vibración corta donde se pueda)
        var lab = e.target && e.target.id ? packs.querySelector('label[for="' + e.target.id + '"]') : null;
        if (lab && !reduce) {
          lab.classList.remove('ov-pulso');
          void lab.offsetWidth;
          lab.classList.add('ov-pulso');
        }
        vibrar(10);
      });

      // Variantes
      var dataEl = sec.querySelector('[data-ov-variantes]');
      var fieldsets = sec.querySelectorAll('[data-ov-opcion]');
      if (dataEl && fieldsets.length) {
        var variantes = JSON.parse(dataEl.textContent);
        var idInput = sec.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        var btn = sec.querySelector('[data-ov-submit]');
        var btnTxt = btn ? btn.querySelector('[data-ov-submit-txt]') : null;
        function actualizar() {
          var sel = [];
          fieldsets.forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) {
            if (btn) { btn.setAttribute('disabled', 'disabled'); }
            if (btnTxt) btnTxt.textContent = sec.dataset.txtNoDisponible;
            return;
          }
          if (idInput) idInput.value = v.id;
          if (precioEl) precioEl.textContent = money(v.price);
          if (antesEl) {
            var hay = v.compare_at_price && v.compare_at_price > v.price;
            antesEl.hidden = !hay;
            if (hay) antesEl.textContent = money(v.compare_at_price);
            if (ahorroEl) {
              ahorroEl.hidden = !hay;
              if (hay) ahorroEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
            }
          }
          if (btn) {
            if (v.available) { btn.removeAttribute('disabled'); if (btnTxt) btnTxt.textContent = sec.dataset.txtComprar; }
            else { btn.setAttribute('disabled', 'disabled'); if (btnTxt) btnTxt.textContent = sec.dataset.txtAgotado; }
          }
          if (cod) cod.hidden = !v.available;
          if (pagar) pagar.hidden = !v.available;
          if (packs) {
            packs.dataset.precio = v.price;
            packs.dataset.antes = v.compare_at_price || 0;
            pintarPacks();
          }
          syncCod();
          if (v.featured_media && minis.length) {
            var idx = minis.findIndex(function (m) { return m.dataset.mediaId == v.featured_media.id; });
            if (idx > -1) mostrar(idx);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        fieldsets.forEach(function (fs) { fs.addEventListener('change', actualizar); });
      }

      // Barra fija móvil
      var barra = sec.querySelector('[data-ov-barra]');
      var ancla = sec.querySelector('[data-ov-submit]');
      if (barra && ancla && 'IntersectionObserver' in window) {
        document.body.appendChild(barra);
        // La barra se ve desde el principio y se esconde solo mientras la zona de compra (opciones y botones) está en pantalla
        var zona = [packs, sec.querySelector('.ov-prod__compra'), cod].filter(Boolean);
        if (!zona.length) zona = [ancla];
        var enPantalla = [];
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var i = enPantalla.indexOf(e.target);
            if (e.isIntersecting && i === -1) enPantalla.push(e.target);
            if (!e.isIntersecting && i > -1) enPantalla.splice(i, 1);
          });
          barra.classList.toggle('ov-barra--visible', enPantalla.length === 0);
        });
        zona.forEach(function (z) { io.observe(z); });
        var barraBtn = barra.querySelector('[data-ov-barra-btn]');
        if (barraBtn) barraBtn.addEventListener('click', function () {
          // Con pago contra entrega como botón principal, la barra abre directamente el pedido contra entrega
          if (barra.hasAttribute('data-cod-primero') && cod && !cod.hidden) { cod.click(); return; }
          // Si aún no se ha llegado a las opciones, la barra lleva hasta ellas; si ya se pasaron, añade al carrito
          var arriba = zona[0].getBoundingClientRect().top > 0;
          if (arriba) {
            var y = zona[0].getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
            return;
          }
          if (ancla.hasAttribute('disabled')) return;
          ancla.click();
        });
      }
    });
  }

  // Fecha estimada de entrega (días hábiles, sin domingos ni festivos)
  function initEntrega(root) {
    (root || document).querySelectorAll('[data-ov-entrega]').forEach(function (box) {
      var txt = box.querySelector('[data-ov-entrega-txt]');
      if (!txt) return;
      var prep = parseInt(box.dataset.prep, 10) || 0;
      var min = parseInt(box.dataset.min, 10) || 1;
      var max = parseInt(box.dataset.max, 10) || min;
      var sabados = box.dataset.sabados === 'true';
      var festivos = (box.dataset.festivos || '').split(/\s+/).filter(Boolean);
      function iso(d) {
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      }
      function habil(d) {
        var dia = d.getDay();
        if (dia === 0) return false;
        if (dia === 6 && !sabados) return false;
        return festivos.indexOf(iso(d)) === -1;
      }
      function sumar(base, n) {
        var d = new Date(base.getTime());
        while (n > 0) { d.setDate(d.getDate() + 1); if (habil(d)) n--; }
        return d;
      }
      var hoy = new Date();
      var desde = sumar(hoy, prep + min);
      var hasta = sumar(hoy, prep + max);
      var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      function fmt(d, conMes) { return dias[d.getDay()] + ' ' + d.getDate() + (conMes ? ' de ' + meses[d.getMonth()] : ''); }
      var mismoMes = desde.getMonth() === hasta.getMonth();
      var tpl = box.dataset.tpl || 'Recíbelo entre el [desde] y el [hasta]';
      txt.innerHTML = tpl
        .replace('[desde]', '<strong>' + fmt(desde, !mismoMes) + '</strong>')
        .replace('[hasta]', '<strong>' + fmt(hasta, true) + '</strong>');
    });
  }

  // Apertura: las fotos de los productos van rotando (se pausa al pasar el ratón y si la pestaña no está visible)
  function initHeroFotos(root) {
    (root || document).querySelectorAll('[data-ov-hero-fotos]').forEach(function (wrap) {
      if (wrap.dataset.ovListo) return;
      wrap.dataset.ovListo = '1';
      var fotos = wrap.querySelectorAll('.ov-hero__foto');
      if (fotos.length < 2) return;
      var media = wrap.closest('.ov-hero__media');
      var puntos = media ? media.querySelectorAll('[data-ov-hero-punto]') : [];
      var ms = parseInt(wrap.dataset.ms, 10) || 4000;
      var actual = 0;
      var timer = null;
      function ir(n) {
        fotos[actual].classList.remove('ov-activa');
        fotos[actual].setAttribute('aria-hidden', 'true');
        fotos[actual].tabIndex = -1;
        if (puntos[actual]) puntos[actual].classList.remove('ov-activa');
        actual = (n + fotos.length) % fotos.length;
        fotos[actual].classList.add('ov-activa');
        fotos[actual].removeAttribute('aria-hidden');
        fotos[actual].tabIndex = 0;
        if (puntos[actual]) puntos[actual].classList.add('ov-activa');
      }
      function parar() { if (timer) { clearInterval(timer); timer = null; } }
      function rotar() { parar(); if (!reduce) timer = setInterval(function () { ir(actual + 1); }, ms); }
      puntos.forEach(function (p, n) { p.addEventListener('click', function () { ir(n); rotar(); }); });
      if (media) {
        media.addEventListener('mouseenter', parar);
        media.addEventListener('mouseleave', rotar);
        alDeslizar(media, function () { ir(actual + 1); rotar(); }, function () { ir(actual - 1); rotar(); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) parar(); else rotar(); });
      rotar();
    });
  }

  // Carrito: el icono da un pequeño salto cuando cambia el número de productos.
  // Si el panel del carrito está abierto (tapa el icono), el salto espera a que se cierre.
  function initCarrito() {
    if (window.__ovCarrito) return;
    var icono = document.getElementById('cart-icon-bubble');
    if (!icono || !('MutationObserver' in window)) return;
    window.__ovCarrito = true;
    var cajon = document.querySelector('cart-drawer');
    var abierto = function () { return !!cajon && cajon.classList.contains('active'); };
    var leer = function () { var b = icono.querySelector('.cart-count-bubble span'); return b ? b.textContent.trim() : '0'; };
    var antes = leer();
    var pendiente = false;
    function saltar() {
      if (abierto()) { pendiente = true; return; }
      pendiente = false;
      if (reduce) return;
      // Si el encabezado está escondido por el scroll, se muestra para que el salto se vea
      var cab = document.querySelector('sticky-header');
      if (cab && typeof cab.reveal === 'function') cab.reveal();
      icono.classList.remove('ov-salta');
      void icono.offsetWidth;
      icono.classList.add('ov-salta');
    }
    var ultimoCambio = 0;
    new MutationObserver(function () {
      var ahora = leer();
      if (ahora === antes) return;
      // Al añadir un producto, el celular da un toque de vibración
      if ((parseInt(ahora, 10) || 0) > (parseInt(antes, 10) || 0)) vibrar(18);
      antes = ahora;
      pendiente = true;
      ultimoCambio = Date.now();
      setTimeout(function () { if (pendiente && !abierto()) saltar(); }, 800);
    }).observe(icono, { childList: true, subtree: true, characterData: true });
    if (cajon) {
      var estabaAbierto = abierto();
      new MutationObserver(function () {
        // Solo cuenta abrir o cerrar el panel; otros cambios de clase (carrito vacío, animación) no
        var ab = abierto();
        if (ab === estabaAbierto) return;
        estabaAbierto = ab;
        // Si el panel se abre justo después del cambio, el salto se guarda para cuando se cierre
        if (ab) { if (Date.now() - ultimoCambio < 2500) pendiente = true; }
        else if (pendiente) setTimeout(saltar, 250);
      }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
    }
    icono.addEventListener('animationend', function (e) {
      if (e.animationName === 'ov-carrito-salto') icono.classList.remove('ov-salta');
    });
    // El panel del carrito también se cierra deslizándolo hacia la derecha
    if (cajon) {
      alDeslizar(cajon, function () {}, function () {
        if (abierto() && typeof cajon.close === 'function') cajon.close();
      });
    }
  }

  // Menú del celular: se abre deslizando el dedo hacia la derecha (empezando en el lado izquierdo de la pantalla)
  // y se cierra deslizando hacia la izquierda. No se activa sobre fotos y carruseles, que ya usan ese gesto.
  function initMenuGesto() {
    if (window.__ovMenuGesto) return;
    var menu = document.querySelector('header-drawer');
    var resumen = menu ? menu.querySelector('summary') : null;
    var detalles = menu ? menu.querySelector('details') : null;
    if (!resumen || !detalles) return;
    window.__ovMenuGesto = true;
    var OCUPADO = '.ov-hero__media, .ov-prod__principal, [data-ov-ba], .ov-visor, cart-drawer, input, textarea, select';
    var x0 = null, y0 = 0, t0 = 0;
    var abierto = function () { return detalles.hasAttribute('open'); };
    function otraCapa() {
      var c = document.querySelector('cart-drawer');
      return !!document.querySelector('.ov-visor') || (!!c && c.classList.contains('active'));
    }
    function deslizaDeLado(el) {
      for (; el && el !== document.body; el = el.parentElement) {
        if (el.scrollWidth > el.clientWidth + 4) {
          var o = window.getComputedStyle(el).overflowX;
          if (o === 'auto' || o === 'scroll') return true;
        }
      }
      return false;
    }
    document.addEventListener('touchstart', function (e) {
      x0 = null;
      // Solo cuando se ven las tres rayitas (celular y tableta)
      if (e.touches.length !== 1 || resumen.offsetParent === null) return;
      var t = e.touches[0];
      if (!abierto()) {
        if (t.clientX > window.innerWidth * 0.4 || otraCapa()) return;
        if (e.target.closest && (e.target.closest(OCUPADO) || deslizaDeLado(e.target))) return;
      }
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0, dt = Date.now() - t0;
      x0 = null;
      if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5 || dt > 800) return;
      if (abierto()) {
        if (dx < 0) resumen.click();
      } else if (dx > 0) {
        // Si el encabezado está escondido por el scroll, primero se muestra para que el menú abra en su sitio
        var cab = document.querySelector('sticky-header');
        if (cab && typeof cab.reveal === 'function') cab.reveal();
        setTimeout(function () { if (!abierto()) resumen.click(); }, 160);
      }
    }, { passive: true });
  }

  // En iOS los estilos :active (respuesta al toque) solo se aplican si hay un listener de toque
  function initToque() {
    if (window.__ovToque) return;
    window.__ovToque = true;
    document.addEventListener('touchstart', function () {}, { passive: true });
  }

  // Carrito: "Pedir y pagar al recibir" abre el formulario contra entrega de la app con todo el carrito.
  // Si la app no está disponible, sigue al pago normal.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ov-carrito-cod]');
    if (!b || b.disabled) return;
    var zona = b.closest('.drawer__footer, .cart__footer, #main-cart-footer') || document;
    var app = zona.querySelector('#rsi_buy_now_button');
    if (!app) {
      var todos = document.querySelectorAll('#rsi_buy_now_button');
      for (var i = 0; i < todos.length; i++) { if (!todos[i].closest('form[data-type="add-to-cart-form"]') && !todos[i].closest('#floatingBuyNowButton')) { app = todos[i]; break; } }
    }
    vibrar(10);
    if (app) { app.click(); return; }
    var pagar = zona.querySelector('[name="checkout"]');
    if (pagar) pagar.click();
  });

  // Acceso rápido de las tarjetas: añade al carrito sin entrar al producto y abre el carrito
  // Pinta el carrito por dentro sin abrirlo y hace saltar el ícono del carrito
  function pintarCarrito(drawer, res) {
    drawer.classList.remove('is-empty');
    // El botón de la app de contra entrega vive dentro del carrito: se guarda y se vuelve a poner tras repintar
    var botonApp = drawer.querySelector('.drawer__footer > #cart-wrapper');
    drawer.getSectionsToRender().forEach(function (sc) {
      var el = sc.selector ? document.querySelector(sc.selector) : document.getElementById(sc.id);
      if (el && res.sections[sc.id]) el.innerHTML = drawer.getSectionInnerHTML(res.sections[sc.id], sc.selector);
    });
    var pie = drawer.querySelector('.drawer__footer');
    if (botonApp && pie && !pie.querySelector('#rsi_buy_now_button')) pie.appendChild(botonApp);
    var fondo = drawer.querySelector('#CartDrawer-Overlay');
    if (fondo) fondo.addEventListener('click', drawer.close.bind(drawer));
  }
  function saltoCarrito() {
    var cab = document.querySelector('sticky-header');
    try { if (cab && cab.reveal) cab.reveal(); } catch (e) {}
    var ic = document.getElementById('cart-icon-bubble');
    if (!ic) return;
    ic.classList.remove('ov-carrito-salto');
    void ic.offsetWidth;
    ic.classList.add('ov-carrito-salto');
    setTimeout(function () { ic.classList.remove('ov-carrito-salto'); }, 1300);
  }
  function anadirRapido(b) {
    if (b.classList.contains('ov-rapido--cargando')) return;
    var drawer = document.querySelector('cart-drawer');
    var id = b.dataset.id, q = b.dataset.q;
    if (b.hasAttribute('data-ov-rapido-ficha')) {
      // En la ficha se añade la opción y la cantidad que el cliente tiene elegidas
      var sec = b.closest('.shopify-section') || document;
      var idEl = sec.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      var qEl = sec.querySelector('[data-ov-qty-form]');
      if (idEl && idEl.value) id = idEl.value;
      if (qEl && qEl.value) q = qEl.value;
    }
    var cuerpo = { items: [{ id: parseInt(id, 10), quantity: Math.max(1, parseInt(q, 10) || 1) }] };
    if (drawer && drawer.getSectionsToRender) {
      cuerpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }
    b.classList.add('ov-rapido--cargando');
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo)
    }).then(function (r) { return r.json(); }).then(function (res) {
      b.classList.remove('ov-rapido--cargando');
      if (res.status) { aviso(res.description || res.message || 'No se pudo añadir'); return; }
      vibrar(12);
      b.classList.add('ov-rapido--ok');
      setTimeout(function () { b.classList.remove('ov-rapido--ok'); }, 1400);
      if (drawer && drawer.getSectionInnerHTML && res.sections) {
        try { pintarCarrito(drawer, res); } catch (e) {}
        saltoCarrito();
        aviso('Añadido al carrito');
      }
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }).catch(function () { b.classList.remove('ov-rapido--cargando'); aviso('No se pudo añadir. Intenta de nuevo.'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ov-rapido]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    anadirRapido(b);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest && e.target.closest('[data-ov-rapido]');
    if (!b) return;
    e.preventDefault();
    anadirRapido(b);
  });

  // Carrusel que se corre solo, muy despacio, y se detiene cuando el cliente lo toca
  function initCarruseles(root) {
    (root || document).querySelectorAll('[data-ov-carrusel]').forEach(function (c) {
      if (c.dataset.ovListo) return;
      c.dataset.ovListo = '1';
      var originales = Array.prototype.slice.call(c.children);
      if (originales.length < 2 || reduce) return;
      var copias = [], pos = 0, pausa = false, visible = false, t = null, ultimo = 0, VEL = 26; // píxeles por segundo
      function preparar() {
        var ancho = 0;
        originales.forEach(function (el) { ancho += el.offsetWidth; });
        var sobra = ancho > c.clientWidth + 4;
        if (sobra && !copias.length) {
          originales.forEach(function (el) {
            var k = el.cloneNode(true);
            k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1'); k.removeAttribute('id');
            c.appendChild(k); copias.push(k);
          });
        }
        c.classList.toggle('ov-carrusel--activo', sobra);
        return sobra;
      }
      function vuelta() { return copias.length ? copias[0].offsetLeft - originales[0].offsetLeft : 0; }
      function paso(ahora) {
        requestAnimationFrame(paso);
        var dt = Math.min(60, ahora - (ultimo || ahora)); ultimo = ahora;
        var v = vuelta();
        if (!v) return;
        if (pausa || !visible) { pos = c.scrollLeft; if (pos >= v) { pos -= v; c.scrollLeft = pos; } return; }
        pos += VEL * dt / 1000;
        if (pos >= v) pos -= v;
        c.scrollLeft = pos;
      }
      function detener() { pausa = true; clearTimeout(t); }
      function seguir(ms) { clearTimeout(t); t = setTimeout(function () { pos = c.scrollLeft; pausa = false; }, ms); }
      c.addEventListener('mouseenter', detener);
      c.addEventListener('mouseleave', function () { seguir(600); });
      c.addEventListener('touchstart', detener, { passive: true });
      c.addEventListener('touchend', function () { seguir(3500); }, { passive: true });
      c.addEventListener('touchcancel', function () { seguir(3500); }, { passive: true });
      c.addEventListener('wheel', function () { detener(); seguir(2500); }, { passive: true });
      c.addEventListener('focusin', detener);
      c.addEventListener('focusout', function () { seguir(1500); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.15 }).observe(c);
      } else visible = true;
      window.addEventListener('resize', preparar);
      preparar();
      requestAnimationFrame(paso);
    });
  }

  function initTodo(root) {
    initReveals(root);
    initCarruseles(root);
    initComparadores(root);
    initProducto(root);
    initEntrega(root);
    initHeroFotos(root);
    initCarrito();
    initToque();
    initMenuGesto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
